import Combobox from '@standardsdigital/ui-components/Combobox';
import type {
  ComboboxAnnouncementTexts,
  ComboboxOption,
} from '@standardsdigital/ui-components/Combobox';
import { useTranslation } from 'react-i18next';
import FieldStatusWrapper from 'components/global/FieldStatusWrapper/FieldStatusWrapper';
import {
  addSelectedValue,
  messageSeverity,
  removeNumberValues,
} from './formInputHelpers';

interface LanguagesSelectProps {
  options: ComboboxOption[];
  selectedOptions: ComboboxOption[];
  value: number[];
  onChange: (value: number[]) => void;
  announcementTexts: ComboboxAnnouncementTexts;
  error?: string;
  isDirty: boolean;
  disabled: boolean;
}

function LanguagesSelect({
  options,
  selectedOptions,
  value,
  onChange,
  announcementTexts,
  error,
  isDirty,
  disabled,
}: Readonly<LanguagesSelectProps>) {
  const { t } = useTranslation();

  return (
    <FieldStatusWrapper isDirty={isDirty}>
      <Combobox
        label={t('serviceLevels.form.languages')}
        options={options}
        selectedOptions={selectedOptions}
        selection="tags"
        selectionModeLabel={t('serviceLevels.form.languages')}
        announcementTexts={announcementTexts}
        clearButtonText={t('general.clearSearch')}
        required
        inputProps={{
          id: 'languages',
          name: 'languages',
          message: error,
          severity: messageSeverity(error),
        }}
        onSelect={(option) =>
          onChange(addSelectedValue(value, Number(option.value)))
        }
        onRemove={(optionsToRemove) =>
          onChange(removeNumberValues(value, optionsToRemove))
        }
        disabled={disabled}
      />
    </FieldStatusWrapper>
  );
}

export default LanguagesSelect;
